import { render, staticRenderFns } from "./PlpSentLog.vue?vue&type=template&id=4eb11e52"
import script from "./PlpSentLog.vue?vue&type=script&lang=js"
export * from "./PlpSentLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports